export var NESTING_KEY = 'children';
export var NESTING_KEY_SEPERATOR = ".".concat(NESTING_KEY, ".");
export var ADD_CHILD_ACTION_PREFIX = 'ADD_CHILD_';
export var REMOVE_ACTION = {
  id: 'REMOVE',
  name: __('Remove'),
  icon: 'icon-trash'
};
export var ADD_ROW_ACTION = {
  id: 'ADD_ROW',
  name: __('Add New'),
  icon: 'icon-add-circle'
};
export var PRINT_ACTION = {
  id: 'PRINT',
  name: 'Print',
  icon: 'icon-printer2'
};